import { createAction } from 'redux-actions';

import {
  SET_FLASH_MESSAGE,
  CLEAR_FLASH_MESSAGE,
} from 'app/features/flashMessage/actionTypes';

const setFlashMessage = createAction(SET_FLASH_MESSAGE);
const clearFlashMessage = createAction(CLEAR_FLASH_MESSAGE);

export { setFlashMessage, clearFlashMessage };
